import type React from 'react';

import { useTheme } from '~ai-tutor/lib/useTheme';

const HaufeLogo: React.FC<{ width?: number; height?: number; className?: string }> = ({
  width = 300,
  height = 80,
  className = '',
}) => {
  const { theme } = useTheme();
  const logoSrc =
    theme === 'dark'
      ? '/assets/haufe-akademie-rgb-logo-package/logo/svg/haufe-akademie-rgb-logo-white.svg'
      : '/assets/haufe-akademie-rgb-logo-package/logo/svg/haufe-akademie-rgb-logo-main.svg';

  return (
    <img
      src={logoSrc}
      alt="Haufe Logo"
      width={width}
      height={height}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
};

export default HaufeLogo;
